export default __webpack_public_path__ + "static/media/myjourney-greentree-fruitflower.6673a873.svg";